import React from "react";

// reactstrap components
import { Row, Col } from "reactstrap";

// core components

function CohortGalleryHeader() {
  let pageHeader = React.createRef();
  /*
  React.useEffect(() => {
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });*/
  return (
    <>
      <div className="page-header page-header-small">
        <div
          className="page-header-image"
          style={{
            backgroundImage: "url(" + require("assets/img/presentation-page/OutsideSandCourt4.jpg") + ")",
          }}
          ref={pageHeader}
        ></div>
        <div className="content-center">
          <Row>
            <Col className="ml-auto mr-auto" md="8">
              <h1 className="title">Cohorts Galleries</h1>
              <h4>
                Check out some of our great images and memories in our Cohort Gallery Collections below!
              </h4>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
}

export default CohortGalleryHeader;
